export function transformFeedbackSetting(f) {
  return {
    id: f.id,
    sendOnResolved: f.sendOnResolved,
    sendOnClosed: f.sendOnClosed,
    sendManually: f.sendManually,
    allowOnlyOneFeedback: f.allowOnlyOneFeedback,
  }
}
